import React from 'react';
import PropTypes from 'prop-types';
import Drawer from 'housecall-ui/dist/DesignSystem/Navigation/Drawers/Drawer';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import HousecallThemeProvider from 'housecall-ui/dist/DesignSystem/Styles/HousecallThemeProvider';
import TasksBootstrap from '../Tasks/TasksBootstrap';

const useStyles = makeStyles(() => ({
  paper: {
    width: 400,
    overflowX: 'hidden',
  },
}));

const TasksDrawer = ({ tasksDrawerOpen, toggleTasksDrawer, closeTasksDrawer }) => {
  const { paper } = useStyles();
  return (
    <HousecallThemeProvider>
      <Drawer
        open={tasksDrawerOpen}
        onClose={toggleTasksDrawer}
        anchor="right"
        classes={{
          paper,
        }}
      >
        <TasksBootstrap
          closeTasksDrawer={closeTasksDrawer}
          toggleTasksDrawer={toggleTasksDrawer}
        />
      </Drawer>
    </HousecallThemeProvider>
  );
};

TasksDrawer.propTypes = {
  tasksDrawerOpen: PropTypes.bool,
  toggleTasksDrawer: PropTypes.func,
  closeTasksDrawer: PropTypes.func,
};

export default TasksDrawer;
